export function getQueryParam(queryString, key) {

    if (!queryString || !key) return undefined;

    const query = queryString[0] === '?' ? queryString.substring(1) : queryString;

    if (!query) return undefined;

    for (const params of query.split('&')) {
        const [k, value] = params.split('=');
        if (key === k) {
            return decodeURIComponent(value);
        }
    }

    return undefined;
}
